<main id="content" role="main" class="main">
    <!-- Content -->
    <div class="content container">
        <div >
            <nav aria-label="breadcrumb">
                <ol id="w1" class="breadcrumb">
                    <li class="breadcrumb-item">الرئيسية</li>
                    <li class="breadcrumb-item active" aria-current="page">المستثمرين</li>
                </ol>
            </nav>
        </div>
        <div class="user-index" >

            <h1>المستثمرين</h1>


            <div id="w0" class="grid-view">
                <!-- <div class="summary">Showing <b>1-20</b> of <b>3,726</b> items.</div> -->
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th><a href="/user/index?user=&amp;sort=username" data-sort="username">Username</a></th>
                            <th><a href="/user/index?user=&amp;sort=name_en" data-sort="name_en">Name En</a></th>
                            <th><a href="/user/index?user=&amp;sort=name_ar" data-sort="name_ar">Name Ar</a></th>
                            <th><a href="/user/index?user=&amp;sort=nationality" data-sort="nationality">Nationality</a>
                            </th>
                            <th><a href="/user/index?user=&amp;sort=mobile" data-sort="mobile">Mobile</a></th>
                            <th class="action-column">&nbsp;</th>
                        </tr>
                        <tr id="w0-filters" class="filters">
                            <td>&nbsp;</td>
                            <td><input type="text" class="form-control" name="userName" [(ngModel)]="userName" (blur)="search()"></td>
                            <td><input type="text" class="form-control" name="nameEn" [(ngModel)]="nameEn" (blur)="search()"></td>
                            <td><input type="text" class="form-control" name="nameAr" [(ngModel)]="nameAr" (blur)="search()"></td>
                            <td><input type="text" class="form-control" name="nationality" [(ngModel)]="nationality" (blur)="search()"></td>
                            <td><input type="text" class="form-control" name="mobil" [(ngModel)]="mobil" (blur)="search()"></td>
                            <td>&nbsp;</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr data-key="1" *ngFor="let item of requests;let i=index">
                            <td>
                                {{item.id}}
                            </td>
                            <td>

                                <a href="/{{mainPath}}/ControlPanel/UserView?id={{item.nationalId}}" title="View" aria-label="View" data-pjax="0">
                                    {{item.nationalId}}
                                </a>

                             
                            </td>
                            <td>
                                {{item.nameEn}}
                            </td>
                            <td>
                                {{item.name}}
                            </td>
                            <td>
                                {{item.nationality}}
                            </td>
                            <td>
                                {{item.mobile}}
                            </td>
                            <td><a href="/{{mainPath}}/ControlPanel/UserView?id={{item.nationalId}}" title="View" aria-label="View" data-pjax="0"><svg
                                        aria-hidden="true"
                                        style="display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em;width:1.125em"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path fill="currentColor"
                                            d="M573 241C518 136 411 64 288 64S58 136 3 241a32 32 0 000 30c55 105 162 177 285 177s230-72 285-177a32 32 0 000-30zM288 400a144 144 0 11144-144 144 144 0 01-144 144zm0-240a95 95 0 00-25 4 48 48 0 01-67 67 96 96 0 1092-71z">
                                        </path>
                                    </svg></a></td>
                        </tr>
                    </tbody>
                </table>
                <ul class="pagination">
                    <li class="prev"><span (click)="goPrevIndex()">«</span></li>
                   
                    <li [ngClass]="item==currentIndex?'active':null" *ngFor="let item of pages| slice:currentIndex-1:currentIndex+9"><a (click)="updatePagination(item)">{{item}}</a></li>
                    <li class="next"><a (click)="goNextIndex()" data-page="1">»</a></li>
                </ul>
            </div>

        </div>
    </div>
    <!-- End Content -->
</main>